module.exports = require("vscode");